import { MenuItem } from '@chakra-ui/react';
import React from 'react';
export const UsersTableActionMenuItem = (props) => React.createElement(MenuItem, { onClick: props.onClick }, props.children);
